import { api } from '../../api';
import { authStore } from '../../core/stores/auth-store';

import type { Member } from '../../app/entities';

/**
 * Resolve the current user's member for the active space outside of a React
 * component (see useCurrentMember for the hook variant)
 */
export const getCurrentMember = (): Member | undefined => {
  const spaceId = api.getSpaceIdFromHeaders();

  if (!spaceId) {
    return undefined;
  }

  return authStore.currentUser?.members.find((member) => member.spaceId === spaceId);
};
